import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { disciplineItems } from "@/mocks/homeData";

const stages = ["全部", "处理中", "已回应", "已处分"];

const stageStyles: Record<string, string> = {
  处理中: "bg-primary-100 text-primary-900",
  已回应: "bg-secondary-100 text-secondary-900",
  已处分: "bg-accent-100 text-accent-900",
};

export default function DisciplineTracker() {
  const [stage, setStage] = useState("全部");
  const list = stage === "全部" ? disciplineItems : disciplineItems.filter((item) => item.stage === stage);

  return (
    <section id="results" className="w-full border-y border-foreground-900/10 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-24">
        <Reveal>
          <SectionHeading
            index="05"
            eyebrow="Discipline Result"
            title="处分结果追踪表"
            desc="从处理中到已处分，每起事件的进度都记录在这里。按状态筛选，可以看到哪些事件已经有了明确结论。"
          />
        </Reveal>

        <Reveal className="mt-8 md:mt-12" delay={60}>
          <div className="inline-flex flex-wrap items-center gap-1 rounded-full border border-foreground-900/10 bg-background-100 p-1">
            {stages.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setStage(item)}
                className={[
                  "cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors",
                  stage === item
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950",
                ].join(" ")}
              >
                {item}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-6 flex flex-col md:mt-8">
          {list.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <div className="grid gap-3 border-t border-foreground-900/10 py-6 md:grid-cols-12 md:items-center md:gap-6">
                <div className="md:col-span-4">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full border border-accent-200 bg-accent-50 px-2.5 py-1 text-[11px] text-accent-900">
                      {item.tag}
                    </span>
                    <span className={`rounded-full px-2.5 py-1 text-[11px] ${stageStyles[item.stage] ?? ""}`}>
                      {item.stage}
                    </span>
                  </div>
                  <h4 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.title}
                  </h4>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600 md:col-span-6">{item.result}</p>
                <div className="flex items-center justify-between md:col-span-2 md:justify-end">
                  <span className="font-heading text-sm text-foreground-500">{item.date}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {list.length === 0 ? (
          <p className="border-t border-foreground-900/10 py-10 text-center text-sm text-foreground-500">
            该状态下暂时没有记录。
          </p>
        ) : null}
      </div>
    </section>
  );
}